/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/ban-types */
export const getMapValue = (key: string, map: object): [string, string] =>
  map[key as keyof typeof map];
